import styled from '@emotion/styled';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var BodyText = styled.p({
  margin: '0px',
  lineHeight: 'inherit',
  letterSpacing: '-0.005em'
});